<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :ok-button-props="{ style: { display: 'none' } }"
    cancel-text="关闭"
    :maskClosable="maskClosable"
    @cancel="$emit('close')"
  >
    <div>
      <!-- <uploader :options="options" class="uploader-example">
        <uploader-unsupport></uploader-unsupport>
        <uploader-drop>
          <p>Drop files here to upload or</p>
          <uploader-btn>select files</uploader-btn>
          <uploader-btn :attrs="attrs">select images</uploader-btn>
          <uploader-btn :directory="true">select folder</uploader-btn>
        </uploader-drop>
        <uploader-list></uploader-list>
      </uploader> -->
    </div>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { requestUrl } from '@/utils/request_url'
const fields = []
export default {
  name: 'FileUploader',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '文件上传',
    },
    visible: {
      type: Boolean,
      required: true,
    },
    maskClosable:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      headers: {},
      maskClose: false,
      options: {
        target: '',
        maxChunkRetries: 2,
        testChunks: false,
        fileParameterName: 'contents',
        chunkSize: 1024 * 1024 * 1024,
        simultaneousUploads: 3,
        query: {
          type: '',
          create_time: '',
        },
        headers: {
          Authorization: token,
        },
      },
      statusText: {
        success: '上传成功',
        error: '上传失败',
        uploading: '上传中',
        paused: '暂停中',
        waiting: '等待中',
      },
      attrs: {
        accept: [],
      },
      file_total: 0, //本次文件上传的总数
      errorfilelist: [], //上传失败信息列表
      controllerErrorFileDialog: false,
    }
  },
  created() {},
  computed: {
    uploadPath() {
      return requestUrl + '/train/rest/file/upload_project_icon'
    },
  },
  mounted() {},
  methods: {
    onFileAdded(file) {
      let file_type = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = file_type === this.uploadType
      if (!extension) {
        let obj = {
          rootname: '无',
          name: file.name,
          errorinfo: '文件不是 ' + this.uploadType + ' 格式',
        }
        let arr = file.relativePath.split('/')
        if (arr.length > 1) {
          obj['rootname'] = arr[0]
        }
        this.errorfilelist.push(obj)
        file.ignored = true
      } else {
        file.pause()
      }
      this.$nextTick(() => {
        this.file_total = this.$refs['uploader'].files.length
      })
      if (this.errorfilelist.length !== 0) {
        this.controllerErrorFileDialog = true
      }
    },

    //每个文件传输给后端之后，返回的信息
    onFileSuccess(rootFile, file, response, chunk) {
      let res = JSON.parse(response)
      if (res.code !== 10000) {
        let obj = {
          rootname: '无',
          name: file.name,
          errorinfo: res.message,
        }
        if (rootFile.isFolder === true) {
          obj['rootname'] = rootFile.name
        }
        this.errorfilelist.push(obj)
        this.controllerErrorFileDialog = true
      }
    },
    // 上传错误触发，文件还未传输到后端
    onFileError(rootFile, file, response, chunk) {
      let obj = {
        rootname: '无',
        name: file.name,
        errorinfo: '文件上传失败',
      }
      if (rootFile.isFolder === true) {
        obj['rootname'] = rootFile.name
      }
      this.errorfilelist.push(obj)
      this.controllerErrorFileDialog = true
    },
    // 移除文件
    fileRemoved(file) {
      this.$nextTick(() => {
        this.file_total = this.$refs['uploader'].files.length
      })
    },
    //点击开始上传按钮
    submitUpload() {
      this.$nextTick(() => {
        for (var i = 0; i < this.$refs['uploader'].files.length; i++) {
          this.$refs['uploader'].files[i].resume()
        }
      })
    },
    //关闭错误文件提示框口，知道上传对话框被关闭时才会被清空
    closeErrorDialog() {
      this.errorDialog = false
    },
    // 上传弹框关闭
    handelClose() {
      this.clearcache()
      this.thirdDialog = false
    },
    // 清除缓存
    clearcache() {
      this.file_total = 0
      this.errorfilelist = []
      this.controllerErrorFileDialog = false
      this.$refs.uploader.uploader.cancel()
      this.getresourceDetail()
    },
    //取消上传
    cancelUpload() {
      this.thirdDialog = false
      this.clearcache()
    },
  },
}
</script>
<style lang="less" >
.uploader-example {
  width: 90%;
  padding: 15px;
  margin: 0 auto 0;
  font-size: 14px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}
.uploader-example .uploader-btn {
  margin-right: 8px;
  color: #ffffff;
  border: #ffffff;
}
/deep/ .uploader-example .uploader-list {
  max-height: 300px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
  .uploader-file[status='uploading'] > .uploader-file-info {
    > .uploader-file-status > span > i {
      visibility: hidden;
    }
    > .uploader-file-status > span > em {
      visibility: hidden;
    }
  }
}
</style>
